/** Scroll cap for embedded Rules demos (rank + leagues). */
export const RULES_DEMO_MAX_H = { base: 'min(75vh, 768px)', lg: '90vh' } as const;

/** Compete demo mobile tabs — mirrors edit-list tab styling. */
export const RULES_LEAGUE_TAB_LIST = 'Leagues';
export const RULES_LEAGUE_TAB_LEADERBOARD = 'Leaderboard';
